mutation CreatePlatformMenuItem($input: CreatePlatformMenuItemInput!) {
  createPlatformMenuItem(input: $input) {
    id
    index
    label
    linkType
    href
    targetType
    targetId
    targetTitle
    visibilityConditions {
      userType
      countries {
        type
        countryCodes
      }
      applicationPlatforms {
        type
        platforms
      }
    }
    targetUrl
    publishAt
  }
}
